import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectPageType } from '../../selectors/page';
import { ReportPageContainer } from '../ReportPageContainer';
import { EPageType } from '../../types/redux/page';
import { CalculatorPageContainer } from '../CalculatorPageContainer';
import { SuburbanPageContainer } from '../SuburbanPageContainer';

export const PagesRouter: React.FC = () => {
  const pageType = useSelector(selectPageType);

  switch (pageType) {
    case EPageType.ReportCreator:
    case EPageType.ReportReady:
      return <ReportPageContainer />;

    case EPageType.Calculator:
    case EPageType.MyHomeDetailed:
      return <CalculatorPageContainer />;

    case EPageType.CalculatorSuburban:
    case EPageType.MyHomeSuburbanDetailed:
      return <SuburbanPageContainer />;
  }
};

PagesRouter.displayName = 'PagesRouter';
